// PlayerManager.js
var PlayerManager = pc.createScript('playerManager');


PlayerManager.prototype.initialize = function() {
    
    PlayerManager.instance = this;
    
    this.userData = new UserData();
    this.levelData = new LevelData();
    this.app.on('UserData',this.GetUserData,this);
};

PlayerManager.prototype.GetUserData = async function(){
    
    var isNewUser = localStorage.getItem('PairUp:isNewUser');
  
    if (isNewUser == null || isNewUser == "" || isNewUser == false) {
        
        playerData = new UserData();
        localStorage.setItem("PairUp:isNewUser", false);
        localStorage.setItem("PairUp:PlayerData", JSON.stringify(this.userData));
    }
    else {
        playerData = JSON.parse(localStorage.getItem('PairUp:PlayerData'));
    }

    this.loadUserData(playerData);
    
    currentRankName = detectCurrentLevel()[0];

    SplashLoadingBar.instance.setProgress(0.2);
    
    this.GetUserLevel("initialization", true, function(status){});
};

PlayerManager.prototype.GetUserLevel = async function (preloadStatus) {

    var userLevel = "";
    
    if (preloadStatus == "updateLevel") {
        userLevel = GameData.instance.getLevelData(this.userData.level);
        this.loadLevelData(userLevel);
        GameManager.instance.CheckNewLevel(userLevel.levelRoom);
        
    }
    else if (preloadStatus == "initialization") {

            userLevel = GameData.instance.getLevelData(playerData.level);
            this.loadLevelData(userLevel);
        SplashLoadingBar.instance.loadTextureAsset();
    }
};


PlayerManager.prototype.loadUserData = function(data){

        this.userData.level = data.level;
        this.userData.score = data.score;
        this.userData.userScore = data.userScore;
        this.userData.unlockLevel = data.unlockLevel;
        this.userData.newPlayer = data.newPlayer;
        this.userData.unlockFriends = data.unlockFriends;
        this.userData.shakeTutorial = data.shakeTutorial;
        this.userData.jokerTutorial = data.jokerTutorial;
        this.userData.interruption = data.interruption;
        this.userData.roomAssets = data.roomAssets;
        this.userData.lastTimeProgressBar = data.lastTimeProgressBar;
        this.userData.savedMatchedObjectCount = data.savedMatchedObjectCount;
        this.userData.gameSound = data.gameSound;
        shakeAnimationIsComplete = data.shakeTutorial;
        jokerAnimationIsComplete = data.jokerTutorial;
        unlockFriendsCount = data.unlockFriends;
    
};

PlayerManager.prototype.loadLevelData = function(data) {
        
    if (this.userData.newPlayer == false) {
        this.levelData.levelID = data.levelID;
        this.levelData.levelName = data.levelName;
        this.levelData.levelItem = data.levelItem;
        this.levelData.objectCount = data.objectCount;
        this.levelData.time = data.time;
        this.levelData.levelTemplate = data.levelTemplate;
        this.levelData.levelRoom = data.levelRoom;
        this.levelData.minObjectCount = data.objectCount;
    }
    else {
        this.loadTutorialData();
    }

};

PlayerManager.prototype.loadTutorialData = function () {

    this.levelData.levelID = 0;
    this.levelData.levelName = "Donut Shop";
    this.levelData.levelItem = "DonutItem";
    this.levelData.objectCount = 3;
    this.levelData.time = 30;
    this.levelData.levelTemplate = "DonutShop";
    this.levelData.levelRoom = "DonutShop";
    this.levelData.minObjectCount = 3;
};


PlayerManager.prototype.SavePlayerData = function () {
    
    localStorage.setItem("PairUp:PlayerData", JSON.stringify(this.userData));
    playerData = JSON.parse(localStorage.getItem('PairUp:PlayerData'));
};

PlayerManager.prototype.SaveLevelData = function () {

    this.createdLevelData = new LevelData();

    this.createdLevelData.levelID = this.levelData.levelID;
    this.createdLevelData.levelName = this.levelData.levelName;
    this.createdLevelData.levelItem = this.levelData.levelItem;
    this.createdLevelData.objectCount = spawnPositions[0].children.length/2;
    this.createdLevelData.time = _remainTime;
    this.createdLevelData.levelTemplate = this.levelData.levelTemplate;
    this.createdLevelData.minObjectCount = this.levelData.minObjectCount;

    localStorage.setItem("backupLevelData", JSON.stringify(this.createdLevelData));
};

PlayerManager.prototype.getUserLevelByUserScore = function () {

    let score = this.userData.userScore;

    if (score >= 100000) return 8;
    else if (score >= 50000) return 7;
    else if (score >= 10000) return 6;
    else if (score >= 5000) return 5;
    else if (score >= 1000) return 4;
    else if (score >= 500) return 3;
    else if (score >= 100) return 2;
    else if (score >= 0) return 1;
};

PlayerManager.prototype.spawnObjectCountByUserScore = function(inputScore) {

    let score;

    if (inputScore != undefined) { score = inputScore;}
    else {
        score = this.userData.userScore;
    }

    if (score >= 100000) return 40;
    else if (score >= 50000) return 35;
    else if (score >= 10000) return 30;
    else if (score >= 5000) return 28;
    else if (score >= 1000) return 26;
    else if (score >= 500) return 24;
    else if (score >= 100) return 22;
    else if (score >= 0) return 20;
};

